module.exports = __webpack_public_path__ + "static/img/tabbar_3_active.14098d33.gif";